const joseJWT = require("jose");
const CryptoJS = require("crypto-js");
const { secret, AES_KEY_ECD, AES_IV_ECD, AES_KEY_256_GCM, AES_IV_256_GCM } = require("../config/config.json");
const crypto = require("crypto");
const moment = require('moment');
export const searchByName = (listData, searchValue) => {
  if (searchValue.length > 0) {
    const searchResult = listData.filter((item) =>
      item.name.toLocaleLowerCase().match(searchValue.toLowerCase())
    );
    return searchResult;
  } else {
    return listData;
  }
};

export const getRoute = (pathname) => {
  const str = pathname.split("/");
  return `/${str[1]}`;
};

export const getTimeSession = async (jwt, key) => {
  const secret = new TextEncoder().encode(key);
  const result = await joseJWT.jwtVerify(jwt, secret);
  return result.payload.exp;
};

export const getDocumentNumber = async (jwt, key) => {
  const secret = new TextEncoder().encode(key);
  const result = await joseJWT.jwtVerify(jwt, secret);
  return result.payload.documentNumber;
};
export const getTypeDocument = async (jwt, key) => {
  const secret = new TextEncoder().encode(key);
  const result = await joseJWT.jwtVerify(jwt, secret);
  return result.payload.documentType;
};

export const getName = async (jwt, key) => {
  const secret = new TextEncoder().encode(key);
  const result = await joseJWT.jwtVerify(jwt, secret);
  return result.payload.fullName;
};

export const getExpiresIn = async (jwt, key) => {
  const secret = new TextEncoder().encode(key);
  const result = await joseJWT.jwtVerify(jwt, secret);
  return parseInt(result.payload.expiresIn.replace(/[^\d]/g, ""));
};

export const convertPassword = async (password) => {
  return CryptoJS.AES.encrypt(password, secret).toString();
};

export const encryptStorage = async (data) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(AES_KEY_ECD);
    const iv = CryptoJS.enc.Utf8.parse(AES_IV_ECD);
    const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    const encryptedText = encrypted.toString();
    return encryptedText;
  } catch (error) {
    console.error("Error al encriptar:", error);
    return null;
  }
};

export const decryptStorage = (data) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(AES_KEY_ECD);
    const iv = CryptoJS.enc.Utf8.parse(AES_IV_ECD);
    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(data)
      },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    const originalText = decrypted.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (error) {
    console.error("Error al descifrar:", error);
    return null;
  }
}


export const decryptGCM = (cipherTextBase64, tagBase64) => {
  const cleanCipher = cipherTextBase64.replace(/\s+/g, "");

  const key = Buffer.from(AES_KEY_256_GCM, "utf8");
  const iv = Buffer.from(AES_IV_256_GCM, "utf8");

  const cipherText = Buffer.from(cleanCipher, "base64");
  const tag = Buffer.from(tagBase64, "base64");

  const decipher = crypto.createDecipheriv("aes-256-gcm", key, iv);
  decipher.setAuthTag(tag);
  decipher.setAutoPadding(false);

  const decipher2 = crypto.createDecipheriv("aes-256-gcm", key, iv);
  decipher2.setAuthTag(tag);
  const decrypted = decipher2.update(cipherText);
  return JSON.parse(decrypted.toString("utf8"));
};

export const getTimeSessionMinutes = (local) => {
  let actualDate = new Date(Date.now());
  let parameterDate = new Date(local * 1000);
  let diference = (actualDate.getTime() - parameterDate.getTime()) / 1000 / 60;
  return Math.abs(Math.round(diference));
};


export const getDateFormatSearch = (date, type) => {
  let dateMoment = moment(date);

  // Obtener los componentes de fecha y hora
  const year = dateMoment.year();
  const month = dateMoment.month() + 1;
  const day = dateMoment.date();
  // Crear una cadena de fecha y hora en el formato deseado
  let formatDate;

  if (type === "desde") {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"0".padStart(2, "0")}:${"0".padStart(
      2,
      "0"
    )}:${"0".padStart(2, "0")}.${"1".padStart(3, "0")}Z`;
  } else {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"23".padStart(2, "0")}:${"59".padStart(
      2,
      "0"
    )}:${"59".padStart(2, "0")}.${"59".padStart(3, "0")}Z`;
  }

  return formatDate;
};
export const getDateFormatSearchAgreements = (date, type) => {
  let dateMoment = moment(date);

  // Obtener los componentes de fecha
  const year = dateMoment.year();
  const month = dateMoment.month() + 1;
  const day = dateMoment.date();
  // Crear una cadena de fecha en el formato deseado
  let formatDate =`${year}/${month.toString().padStart(2, "0")}/${day.toString().padStart(2, "0")}`;

  return formatDate;
};
export const getDateFormatSearchElectronic = (date, type) => {
  let dateMoment = moment(date);

  // Obtener los componentes de fecha y hora
  const year = dateMoment.year();
  const month = dateMoment.month() + 1;
  const day = dateMoment.date();
  // Crear una cadena de fecha y hora en el formato deseado
  let formatDate;

  if (type === "desde") {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"0".padStart(2, "0")}:${"0".padStart(
      2,
      "0"
    )}:${"0".padStart(2, "0")}.${"1".padStart(3, "0")}`;
  } else {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"23".padStart(2, "0")}:${"59".padStart(
      2,
      "0"
    )}:${"59".padStart(2, "0")}.${"59".padStart(3, "0")}`;
  }

  return formatDate;
};
export const getDateFormatSearchRequestManager = (date) => {
  let dateMoment = moment(date);

  // Obtener los componentes de fecha
  const year = dateMoment.year();
  const month = dateMoment.month() + 1;
  const day = dateMoment.date();

  // Crear una cadena de fecha en el formato deseado
  const formatDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

  return formatDate;
};

export const getDateFormatSearchChecker = (date, type) => {
  const dateSearch = moment(date);

  // Obtener los componentes de fecha y hora
  const year = dateSearch.year();
  const month = dateSearch.month() + 1;
  const day = dateSearch.date();
  // Crear una cadena de fecha y hora en el formato deseado
  let formatDate;

  if (type === "desde") {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"0".padStart(2, "0")}:${"0".padStart(
      2,
      "0"
    )}:${"0".padStart(2, "0")}Z`;
  } else {
    formatDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${"23".padStart(2, "0")}:${"59".padStart(
      2,
      "0"
    )}:${"59".padStart(2, "0")}Z`;
  }

  return formatDate;
};
export const getFormattedDateWithOffset = (daysOffset) => {
  const currentDate = moment();
  const offsetDate = moment().subtract(daysOffset, 'days');

  const formattedCurrentDate = currentDate.format('YYYY/MM/DD');
  const formattedOffsetDate = offsetDate.format('YYYY/MM/DD');

  return { formattedCurrentDate, formattedOffsetDate };
};

export const getFormattedDateWithOffsetLogistic = (daysOffset) => {
  const currentDate = moment();
  const offsetDate = moment().subtract(daysOffset, 'days');

  const formattedCurrentDate = currentDate.toISOString();
  const formattedOffsetDate = offsetDate.toISOString();

  return { formattedCurrentDate, formattedOffsetDate };
};

export const getFormatDateChecker = () => {
  const actualDate = new Date();
  const minusDate = new Date();
  minusDate.setDate(minusDate.getDate() - 7);
  // Obtener los componentes de fecha y hora
  const actualYear = actualDate.getUTCFullYear();
  const actualMonth = actualDate.getUTCMonth() + 1;
  const actualDay = actualDate.getUTCDate();
  const minusYear = minusDate.getUTCFullYear();
  const minusMonth = minusDate.getUTCMonth() + 1;
  const minusDay = minusDate.getUTCDate();
  // Crear una cadena de fecha y hora en el formato deseado

  const formatActualDate = `${actualYear}-${actualMonth
    .toString()
    .padStart(2, "0")}-${actualDay.toString().padStart(2, "0")}T${"23".padStart(
    2,
    "0"
  )}:${"59".padStart(2, "0")}:${"59".padStart(2, "0")}Z`;
  const minusActualDate = `${minusYear}-${minusMonth
    .toString()
    .padStart(2, "0")}-${minusDay.toString().padStart(2, "0")}T${"0".padStart(
    2,
    "0"
  )}:${"0".padStart(2, "0")}:${"0".padStart(2, "0")}Z`;

  return { formatActualDate, minusActualDate };
};

export const getDocumentsByType = (type, list) => {
  const actualDocument = list
    ? list.filter(
        (item) =>
        item.documentTypeId.match(type) && (item.documentstatusid.match("PEN") || item.documentstatusid.match("APR") || item.documentstatusid.match("NAP"))
      )
    : [];
  const previewDocument = list
    ? list.filter(
        (item) =>
          item.documentTypeId.match(type) && item.documentstatusid.match("DCT")
      )
    : [];
  return {
    actual: actualDocument ? actualDocument[0] : "",
    preview: previewDocument ? previewDocument[0] : "",
  };
};

export const searchPathInList = (path, list) => {
  const actualDocument = list
  ? list.filter(
    (item) =>
    item.filepath?.match(path)
    )
    : [];
    
  return  actualDocument ? actualDocument[0] : "";
};

export const getDocumentsToValidate = (inputs) => {
  let res = [];
  inputs.map((item) => {
    res.push(item.Title);
  });
  return res;
};
export const existValidationInput = (list, name) => {
  let res = true;
  list.map((item) => {
    if (item.fieldName === name) {
      res = false;
    }
  });
  return res;
};

export const validationInputs = (list) => {
  let res = false;
  list.map((item) => {
    if (!item.isValid) {
      res = true;
    }
  });
  return res;
};

export const getAcualDocumentValidate = (name, list) => {
  return list ? list.filter((item) => item.documentTypeId.match(name)) : [];
};

export const getCampValidated = (name, list) => {
  return list && list.fields
    ? list.fields.filter((item) => item.fieldName.match(name))
    : [];
};

export const validateCompleted = (inputs, actualValidate) => {
  let res = true;
  let approved = true;
  inputs.structureValidate.map((input) => {
    let document = actualValidate
      ? actualValidate.filter(
          (item) =>
            item.documentTypeId.match(input.Title) &&
            (item.documentstatusid.match("NAP") ||
              item.documentstatusid.match("APR"))
        )
      : [];
    if (document.length === 0) res = false;
    if (document && document[0] && document[0].documentstatusid === "NAP")
      approved = false;
  });
  return { res, approved };
};

export const returnStateList = (list) => {
  let statusTemp = [];
  list.map((status) => {
    statusTemp.push(status.statusId)
  })
  return statusTemp;
};

export const getDocumentsToValidateCheck = (data) => {
  let res = [];
  data.map((item) => {
    res.push(item.documentType);
  });
  return res;
};

export const checkANINames = (dataForm, dataANI) => {
  let formName = "";
  let ANIName = "";
  formName = (dataForm.firstName + " " + dataForm.secondName + " " + dataForm.firstLastName + " " + dataForm.secondLastName);
  ANIName = (dataANI.firstName + " " + dataANI.secondName + " " + dataANI.surName + " " + dataANI.secondSurname);
  const porcentaje = calculatePercentMatch(formName, ANIName);
  return porcentaje;
};

export const checkDACNames = (dataForm, dataDAC) => {
  let formName = "";
  let dacName = "";
  formName = (dataForm.firstName + " " + dataForm.secondName + " " + dataForm.firstLastName + " " + dataForm.secondLastName);
  dacName = (dataDAC["ciudadano"]["NOMBRES"] + " " + dataDAC["ciudadano"]["APELLIDOS"]);
  const porcentaje = calculatePercentMatch(formName, dacName);
  return porcentaje;
};


export const cleaningString = (cadena) => {
  // Eliminar espacios duplicados y tildes de vocales
  return cadena
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/,/g, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function calculatePercentMatch(str1, str2) {
  const cadena1 = cleaningString(str1);
  const cadena2 = cleaningString(str2);
  const longitudMaxima = Math.max(cadena1.length, cadena2.length);
  const coincidencias = Array.from(cadena1).reduce(
    (count, char, index) => (cadena2[index] === char ? count + 1 : count),
    0
  );
  const porcentajeCoincidencia = (coincidencias / longitudMaxima) * 100;
  return porcentajeCoincidencia.toFixed(0);
}

export const convertFinalArrayByUpdateRequestData = (data) => {
  let { newArray, inputs, states, towns } = data;
  return newArray.map(item => {
    if ((item.key.toLocaleLowerCase().includes("country") || item.key.toLocaleLowerCase().includes("codeiso02")) && item.value) {
      const inputItem = inputs?.find(input => input.name === item.key);
      if (inputItem) {
        const optionItem = inputItem.options.find(option => option.value === item.value);
        if (optionItem) {
          return {
            key: item.key,
            value: optionItem.alternativeValue,
            alternativeValue: item.value
          };
        }
      }
    }
    if (item.key.toLocaleLowerCase().includes("state") && item.value) {
      const stateItem = states?.data?.find(state => state.value == item.value);
      if (stateItem) {
        return {
          key: item.key,
          value: stateItem.label,
          alternativeValue: item.value
        };
      }
    }
    if (item.key.toLocaleLowerCase().includes("town") && item.value) {
      const townItem = towns?.data?.find(state => state.value == item.value);
      if (townItem) {
        return {
          key: item.key,
          value: townItem.label,
          alternativeValue: item.value
        };
      }
    }
    return item;
  });
}

export const groupDocsByType = (data) => {
  let grupos = {};
  data.forEach((document) => {
    if(document.validation !== null){
      if (grupos[document.documentTypeId]) {
        grupos[document.documentTypeId].push(document);
      } else {
        grupos[document.documentTypeId] = [document];
      }
    }
  });
  return grupos;
};

export const excludeDocsWithMinDate = (data) => {
  let documents = [];
  let finalDocumentsToRevise = [];
  for (let groupDocuments in data) {
    if (Object.prototype.hasOwnProperty.call(data, groupDocuments)) {
      documents = data[groupDocuments];
      if (documents.length === 0) {
        return null;
      }
      let fechaMasReciente = new Date(0);
      let objetoConFechaMasReciente = null;
      documents.forEach(document => {
        // Comprueba si el document tiene una propiedad de fecha válida
        let dateActualDoc = new Date(document.validation.validationDateTime);
        if (dateActualDoc instanceof Date) {
          // Actualiza las variables
          if (dateActualDoc > fechaMasReciente) {
            fechaMasReciente = dateActualDoc;
            objetoConFechaMasReciente = document;
          }
        }
      });
      finalDocumentsToRevise.push(objetoConFechaMasReciente);
    }
  }
  return finalDocumentsToRevise;
};

export const listRolesConvert = (listCreateAndEdit,initialList) => {
  initialList.forEach((item) => {
    if(!listCreateAndEdit.includes(item)){
      listCreateAndEdit.push({role : item.role, assigned : false});
    }
  });
  return listCreateAndEdit;
};
export const listToString = (list) => list.map(item => item._id).join(',');

export const encryptTextBM = (message, key, iv) => {
  // Convertir IV a WordArray desde un array de bytes (si iv es un ArrayBuffer o un Uint8Array)
  const ivWordArray = CryptoJS.lib.WordArray.create(iv);

  // Convertir la clave en formato WordArray para AES-256
  const keyWordArray = CryptoJS.lib.WordArray.create(key);

  // Encriptar usando AES-256-CBC con PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(message, keyWordArray, {
    iv: ivWordArray,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Devolver el resultado en base64
  return encrypted.toString();
};

export const decryptTextBM = (encryptedText, key, iv) => {
  // Convertir clave y IV a WordArray (asegúrate de que sean 32 bytes para la clave y 16 bytes para IV)
  const keyWordArray = CryptoJS.lib.WordArray.create(key); 
  const ivWordArray = CryptoJS.lib.WordArray.create(iv);

  // Desencriptar el texto (que está en Base64)
  const decrypted = CryptoJS.AES.decrypt(encryptedText, keyWordArray, {
    iv: ivWordArray,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Convertir el resultado desencriptado de WordArray a texto
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  return decryptedText;
};

export const GetPass = (entry, pRequest) => {
  const timestamp2 = new Date(pRequest.timestamp);
  const result = {};
  const day = timestamp2.getDate().toString().padStart(2, '0');
  const month = (timestamp2.getMonth() + 1).toString().padStart(2, '0');
  const nonceArray = pRequest.nonce.split('-');
  const par = parseInt(day) % 2 === 0;
  let Key = '';
  let Iv = '';
  const nonceOne = nonceArray[0];
  const nonceTwo = nonceArray[1];
  const nonceThree = nonceArray[2];
  const nonceFour = nonceArray[3];
  const nonceFive = nonceArray[4];

  if (par && entry) {
    Key = nonceFive + month + nonceFour + nonceThree + nonceThree + day + nonceOne.substring(0, 4);
    Iv = nonceFour + nonceThree + month + day + nonceTwo;
  } else if (!par && entry) {
    Key = nonceFour + day + month + nonceTwo + nonceOne + nonceTwo + nonceThree + month + day;
    Iv = day + nonceTwo + nonceTwo + month + nonceTwo;
  } else if (par && !entry) {
    Key = nonceThree + nonceFour + month + nonceThree + nonceFive + day + nonceOne.substring(0, 4);
    Iv = nonceFive + month + nonceTwo.substring(0, 2);
  } else if (!par && !entry) {
    Key = nonceFive + nonceOne + nonceThree + nonceTwo + day + month;
    Iv = day + nonceTwo + nonceFive.substring(0, 8) + month;
  }

  const encoder = new TextEncoder();
  result.Key = encoder.encode(Key);
  result.Iv = encoder.encode(Iv);

  return result;
}

// Validacion de datos por convenio para mostrar en plural o en singular el tiempo de vigencia
export const getValidityLabelAgreement = (product, validityLabelsAgreements) => {
  if (!product?.validity || !product?.validityTypeId || !validityLabelsAgreements[product.validityTypeId]) return "- - -";
  const [singular, plural] = validityLabelsAgreements[product.validityTypeId];
  return product.validity === 1 ? `${product.validity} ${singular}` : `${product.validity} ${plural}`;
}